
import $ from 'jquery';
import ns from 'ns';
import Store from 'store';
import User from '../User';
import Snippet from '../Snippet';
import translations from '../Languages';

require('../../views-compiled/menu');

const PROFILE_RESULT_KEY = 'user.profile_result';
const DOMAIN_RESULT_PARTIAL_KEY = 'user.domain_result';
const REQUESTED_PROFILE_RESULT_KEY = 'requested_profile_result';
const REQUESTED_FAMILY_RESULT_KEY = 'requested_family_result';


let rightMenu;
let leftMenu;
let container;
let currentSection;

function swapDepth() {
	if (container.hasClass('leftOpen')) {
		leftMenu.css('z-index', 2);
		rightMenu.css('z-index', 1);
	} else if (container.hasClass('rightOpen')) {
		leftMenu.css('z-index', 1);
		rightMenu.css('z-index', 2);
	}
}

/**
 * Sets the jQuery elements and the events each of them needs to be
 * listening and reacting to.
 */
function initMenus() {
	container = $('#container');
	leftMenu = $('.left-menu');
	rightMenu = $('.right-menu');
	currentSection = $('[data-current-section]');

	const containerAndHeader = $('#container, #header, .mask-menu');
	const quizCta = $('[data-domain-quiz-cta]', rightMenu);
	const familiesCta = $('[data-family-cta]', rightMenu);

	quizCta.off('click.cursus').on('click.cursus', (e) => {
		e.preventDefault();
		const d = $(e.currentTarget).data('domain-id');

		ns.currentSection.animateOut().then(() => {
			Store.set(REQUESTED_PROFILE_RESULT_KEY, d);
			ns.Menu.showProfile();
		});
	});

	familiesCta.off('click.cursus').on('click.cursus', (e) => {
		e.preventDefault();
		const f = $(e.currentTarget).data('family-cta');
		const d = $(e.currentTarget).data('domain-id');

		ns.currentSection.animateOut().then(() => {
			Store.set(REQUESTED_FAMILY_RESULT_KEY, f);
			ns.Menu.showFamily({ id: d });
		});
	});

	containerAndHeader.off('click.cursus').on('click.cursus', () => {
		if (container.hasClass('leftOpen') || container.hasClass('rightOpen')) {
			containerAndHeader.removeClass('rightOpen').removeClass('leftOpen');
		}
	});

	$('.btn-result, .right-menu .btn-close').off('click.cursus').on('click.cursus', (e) => {
		containerAndHeader.removeClass('leftOpen').toggleClass('rightOpen');
		swapDepth();
		e.stopPropagation();
	});
}

/**
 * Renders the Nunjucks templates.
 */
function render(tplName, data = {}) {
	data.lng = translations;
	data.domains = data.domains || data.lng.domains;

	return $(`<div>${window.nunjucks.render(tplName, data)}</div>`).get(0);
}

function Menu(callbackProfile, callbackFamily) {
	this.container = $('.right-menu .nano-content');
	this.templateName = 'menu.htm';

	this.showProfile = callbackProfile;
	this.showFamily = callbackFamily;

	/**
	 * Updates the data used in the rendering of the Menu by using the latest data in the
	 * localStorage. Calls the render function and reactivates the components that need it.
	 */
	this.updateData = () => {
		let dataToRender = {};

		const savedProfileResults = User.get(PROFILE_RESULT_KEY);

		if (savedProfileResults) {
			dataToRender = { domains: savedProfileResults };

			let savedDomainResults = [];
			for (let i = 1; i <= dataToRender.domains.length; i++) {
				savedDomainResults.push(User.get(`${DOMAIN_RESULT_PARTIAL_KEY}_${i}`));
			}

			savedDomainResults = savedDomainResults.filter(x => x !== null);
			if (savedDomainResults.length > 0) {
				savedDomainResults.forEach((domain) => {
					const currDomain = dataToRender.domains.find(d => d.id === domain.domain.id);

					// format families
					currDomain.families = domain.families;
					currDomain.families.forEach((family) => {
						family.prc = Math.ceil(family.ratio * 100);
					});
				});
			}

			dataToRender.bestDomain = dataToRender.domains[0];
		}

		dataToRender.user = User._data;
		dataToRender.user.isLoggedIn = User.isLogged();

		this.sectionNode = render(this.templateName, dataToRender);
		this.container.empty().append(this.sectionNode);

		this.activate();
	};
	
	this.render = (data) => {
		this.updateData();
		return this.sectionNode;
	};

	/**
	 * Activates components that need it.
	 */
	this.activate = () => {
		initMenus();
		// JO NO SHARE! Snippet.refresh(rightMenu.find('[data-share-snippet]'));
	};

	/**
	 * Updates the current section that is used in the headband (upper left corner)
	 * troughout the app.
	 * 
	 * @param {Number|String} section - Number or String that refers to the section you want to show.
	 */
	this.updateCurrentSection = (section) => {
		currentSection.attr('data-current-section', section);
		currentSection.find('span').html(translations.global.steps[section - 1].text);
	};
}

export default Menu;
